/**
 * Scalar maths shared by the deck solver, the tween engine and the UI.
 * Deliberately DOM-free so it runs unchanged under Bun's test runner.
 */

export const TAU = Math.PI * 2;

export const clamp = (v: number, a: number, b: number): number => (v < a ? a : v > b ? b : v);

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

/** Inverse lerp. A degenerate range yields 0 rather than dividing by zero. */
export const inv = (v: number, a: number, b: number): number => (b === a ? 0 : (v - a) / (b - a));

/** Frame-rate independent smoothing: `lambda` is the convergence rate per second. */
export const damp = (cur: number, target: number, lambda: number, dt: number): number =>
  lerp(cur, target, 1 - Math.exp(-lambda * dt));
